module.exports = " <div class=subcategories> <h4 class=text-uppercase v-if=render_subcategories.length>Subcategorías</h4> <div class=custom-checkbox v-for=\"sub in render_subcategories\"> <input type=checkbox class=sub-filters :id=sub.id /> <label :for=sub.id @click=\"toggleSubcategory($event, sub)\">{{ sub.name }}</label> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product/Subcategories.vue
// module id = 556
// module chunks = 0